<div>
  @if (step === 'creating-offer') {
    <div>{{'create_offer_please_wait' | i18next}}</div>
  }
  @if (step === 'select-contact') {
    <app-select-invoice-contact
      [customer]="selectedCustomer"
      [subscription]="subscription"
      (back)="onSelectContactBack()"
      (selected)="onContactSelected($event)"
      >
    </app-select-invoice-contact>
  }
  @if (step === 'select-upgrade') {
    <app-upgrade-one
      [productPrice]="pcOnePrice"
      [productDiscount]="pcOneDiscount"
      [subscription]="subscription"
      [customer]="selectedCustomer"
      (back)="onBackUpgradeOne()"
      (next)="onProductSelected($event)"
      >
    </app-upgrade-one>
  }
  @if (step === 'select-sla') {
    <app-select-one-sla
      [slaProducts]="slaProducts"
      [subscription]="subscription"
      (selected)="onSLAProductSelected($event)"
      (backEmitter)="onSLAProductBack()"
      >
    </app-select-one-sla>
  }
  <!--  If partner-->
  @if ((isPC20CSP || company) && step === 'customer-invoice-address') {
    <app-invoice-address
      [company]="company"
      [onlyEmit]="true"
      (next)="onCustomerInvoiceAddressFilled($event)"
      >
    </app-invoice-address>
  }
  @if ((isPC20CSP || company) && step === 'customer-payment-method') {
    <app-payment-method
      [company]="company"
      [onlyEmit]="true"
      (next)="onCustomerPaymentMethodSelected($event)"
      [paymentMethod]="paymentMethod"
      >
    </app-payment-method>
  }
  <!--  if my-->
  @if (step === 'invoice-address') {
    <app-invoice-address
      (next)="onInvoiceAddressFilled($event)"
      >
    </app-invoice-address>
  }
  @if (step === 'payment-method') {
    <app-payment-method
      (next)="onPaymentMethodSelected()"
      [paymentMethod]="paymentMethod"
      >
    </app-payment-method>
  }
  @if (step === 'checkout-summary') {
    <app-checkout-one-summary
      [subscription]="subscription"
      [historyBack]="false"
      [canEnterReference]="isAdmin"
      (buy)="onBuy()"
      (subscriptionReferenceChange)="onSubscriptionReferenceChanged($event)"
      (back)="onSummaryBack()"
      >
    </app-checkout-one-summary>
  }
  @if (isPascomApproved && step === 'thank-you') {
    <app-buy-thankyou
      [orderName]="orderName">
    </app-buy-thankyou>
  }
  @if (!isPascomApproved && step === 'thank-you') {
    <app-endcustomer-need-pascom-approval
      (next)="onScreenPascomApprovalNext()">
    </app-endcustomer-need-pascom-approval>
  }
  @if (step === 'thank-you-partner') {
    <app-buy-thankyou-partner
      [orderName]="orderName">
    </app-buy-thankyou-partner>
  }
</div>
